import { html } from "../../"
import { T } from "../../global/globals"
import { SYSBaseElement } from "../sysbaseelement"
import type { EditRowSaveCancelDef } from "./table"

import { FormIsValid, FormSave } from "../forms/formapi"
import { _TableFormCloseEditRow } from "./tableapi"

//import { dialogAfterClose } from "../dialog/actions"

export class SYSTableRowSaveCancel extends SYSBaseElement {
  props: any
  rowData: EditRowSaveCancelDef

  async init() {
    this.rowData = this.props()
    this.formState =
      this.state.ovl.forms["SYSTableRowEdit"][
        `${this.rowData.tableDef.id}_${this.rowData.key}`
      ]
    await super.init()
  }
  async getUI() {
    let handleSave = async () => {
      FormSave(this.formState)
    }

    let handleCancel = async (e: Event) => {
      /* @ts-ignore */
      if (e.target.classList.contains("ovl-disabled")) {
        return
      }
      _TableFormCloseEditRow(
        this.formState.tableDefId,
        this.formState.tableRowKey,
        {
          formState: this.formState,
          promptIfDirty: true,
        }
      )
    }

    let acceptEnabled = "fd-button fd-button--positive"
    let acceptEnabledIcon

    let declineEnabled = "fd-button fd-button--negative"
    let declineEnabledIcon

    let formValid = FormIsValid(this.formState)

    if (
      this.formState._state._noCancelOnEditFormIfFormStateWasInvalidWhenOpened
    ) {
      declineEnabled = "fd-button ovl-disabled"
    } else {
      declineEnabledIcon = html`<i class="sap-icon--decline"></i>`
    }

    if (!formValid) {
      acceptEnabled = "fd-button ovl-disabled"
    } else {
      acceptEnabledIcon = html`<i class="sap-icon--accept"></i>`
    }

    return html`
      <td
        colspan="${this.rowData.tableDef.uiState.columnsRenderingState
          .visibleInTable.length}"
        class="fd-table__cell ovl-rowformsavecancel"
      >
        <div
          class="fd-segmented-button animated fadeIn faster ovl-rowformsavecancel1"
          role="group"
          aria-label="RowSaveCancel"
        >
          <button
            @click=${handleSave}
            id="ovl_row_save_save${this._id}"
            title="${T("SYSTableRowFnSave")}"
            class="fd-button--positive ${acceptEnabled} ovl-rowformsavecancel2"
          >
            ${acceptEnabledIcon}
          </button>

          <button
            @click=${async (e) => handleCancel(e)}
            id="ovl_row_save_cancel${this.id}"
            title="${T("SYSCancel")}"
            class="fd-button fd-button--negative ${declineEnabled} ovl-rowformsavecancel3"
          >
            ${declineEnabledIcon}
          </button>
        </div>
      </td>
    `
  }
}
